export enum EulaType {
  terms = 'terms',
  privacyPolicy = 'privacyPolicy',
  conflictInterest = 'conflictInterest',
  termAndPrivacy = 'termAndPrivacy',
  all = 'all'
}
